module.exports = __webpack_public_path__ + "img/tasks_blue.f9d0fa54.png";